import axios from "axios";
import router from '@/router';

const api = axios.create({
  baseURL: /*"http://127.0.0.1:8000/"*/ "https://fibackend.ujed.mx/",
  headers: {
    "Content-type": "application/json",
  },
});

api.interceptors.response.use(
  response => response, 
  error => {
    if (error.response) {
      const code = error.response.status;

      if ([400, 403, 404, 500].includes(code)) {
        router.push({ name: 'ErrorPage', params: { code } });
      }
    } else {
      router.push({ name: 'ErrorPage', params: { code: 500 } });
    }

    return Promise.reject(error);
  }
);

export default api;